import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=00281df2&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=00281df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00281df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00281df2')) {
      api.createRecord('00281df2', component.options)
    } else {
      api.reload('00281df2', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=00281df2&scoped=true&", function () {
      api.rerender('00281df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h29JVzFFrSgZ/JS/teamMember.vue"
export default component.exports